import { createContext } from 'react';
import { type SidebarData } from '../types';

export interface SidebarContextType {
  sidebarData: SidebarData;
}

export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);
